import getIsCurrentThemeModernColor from 'owa-theme/lib/selectors/getIsCurrentThemeModernColor';
import { isBootFeatureEnabled } from 'owa-metatags/lib/isBootFeatureEnabled';

export default function isMicaEffectEnabled(): boolean {
    // Mica effect is only enabled for modern color themes
    // using the new header in Monarch
    return getIsCurrentThemeModernColor() && isBootFeatureEnabled('fwk-new-monarch-header');
}
